import { useQuery } from 'react-query'
import { useAuth0 } from '../../../contexts/auth0-context'
import callAPI from '../../../API/callSecureAPI'
import { ColumnVersionFull } from '../types'

const FIVE_MINUTES = 1000 * 60 * 5

export const useGetTPPColumnVersionQuery = (versionId: string | null) => {
    const { getTokenSilently, isAuthenticated, isLoading } = useAuth0()

    const getColumnVersion = async () => {
        try {
            const token = await getTokenSilently?.({ audience: 'https://atlas.aesara.com' })

            const url = `/api/tpps/column-versions/${versionId}`

            const response = await callAPI(url, 'get', token)

            return response.data as ColumnVersionFull
        } catch (e) {
            console.log(e)
            throw e
        }
    }

    return useQuery<ColumnVersionFull>(['tppColumnVersion', versionId], getColumnVersion, {
        enabled: !!getTokenSilently && !!isAuthenticated && !isLoading && !!versionId,
        cacheTime: FIVE_MINUTES,
        staleTime: FIVE_MINUTES,
        refetchOnWindowFocus: false,
        retry: 3,
    })
}
